import { buildReverseMap } from "./helpers/reverse-map.helper.mjs";
//#region src/process-ids.ts
let ProcessIds = /* @__PURE__ */ function(ProcessIds) {
	ProcessIds[ProcessIds["Inc"] = 1] = "Inc";
	ProcessIds[ProcessIds["LLC"] = 2] = "LLC";
	ProcessIds[ProcessIds["DBA"] = 18] = "DBA";
	ProcessIds[ProcessIds["NonProfit"] = 20] = "NonProfit";
	ProcessIds[ProcessIds["LimitedPartnership"] = 23] = "LimitedPartnership";
	ProcessIds[ProcessIds["LimitedLiabilityPartnership"] = 24] = "LimitedLiabilityPartnership";
	ProcessIds[ProcessIds["Amendment"] = 25] = "Amendment";
	ProcessIds[ProcessIds["CorporateDissolution"] = 26] = "CorporateDissolution";
	ProcessIds[ProcessIds["ForeignQualification"] = 27] = "ForeignQualification";
	ProcessIds[ProcessIds["SmallClaims"] = 35] = "SmallClaims";
	ProcessIds[ProcessIds["SellersPermit"] = 44] = "SellersPermit";
	ProcessIds[ProcessIds["StateTaxID"] = 45] = "StateTaxID";
	ProcessIds[ProcessIds["Conversion"] = 47] = "Conversion";
	ProcessIds[ProcessIds["CertificateOfGoodStanding"] = 29] = "CertificateOfGoodStanding";
	ProcessIds[ProcessIds["BusinessLicenses"] = 57] = "BusinessLicenses";
	ProcessIds[ProcessIds["NonProfit501c3Preparation"] = 59] = "NonProfit501c3Preparation";
	ProcessIds[ProcessIds["GeneralPartnershipAgreement"] = 63] = "GeneralPartnershipAgreement";
	ProcessIds[ProcessIds["JointVentureAgreement"] = 64] = "JointVentureAgreement";
	ProcessIds[ProcessIds["EntityNameAvailabilityCheck"] = 68] = "EntityNameAvailabilityCheck";
	ProcessIds[ProcessIds["CompanyCertificates"] = 77] = "CompanyCertificates";
	ProcessIds[ProcessIds["CompanySeal"] = 78] = "CompanySeal";
	ProcessIds[ProcessIds["CorporateKit"] = 79] = "CorporateKit";
	ProcessIds[ProcessIds["InitialReports"] = 80] = "InitialReports";
	ProcessIds[ProcessIds["AnnualReports"] = 81] = "AnnualReports";
	ProcessIds[ProcessIds["RegisteredAgentServices"] = 83] = "RegisteredAgentServices";
	ProcessIds[ProcessIds["MinutesManagerSubscription"] = 42] = "MinutesManagerSubscription";
	ProcessIds[ProcessIds["EIN"] = 49] = "EIN";
	ProcessIds[ProcessIds["BylawsAndResolutions"] = 75] = "BylawsAndResolutions";
	ProcessIds[ProcessIds["OperatingAgreements"] = 76] = "OperatingAgreements";
	ProcessIds[ProcessIds["CorporateMinutes"] = 39] = "CorporateMinutes";
	ProcessIds[ProcessIds["SCorpPreparation"] = 93] = "SCorpPreparation";
	ProcessIds[ProcessIds["EntityNameReservation"] = 107] = "EntityNameReservation";
	ProcessIds[ProcessIds["ComplianceCalendar"] = 108] = "ComplianceCalendar";
	ProcessIds[ProcessIds["PartnerProducts_CTN"] = 145] = "PartnerProducts_CTN";
	ProcessIds[ProcessIds["BusinessTaxPreparation"] = 157] = "BusinessTaxPreparation";
	ProcessIds[ProcessIds["BusinessTaxConsultation"] = 165] = "BusinessTaxConsultation";
	ProcessIds[ProcessIds["LegalzoomTaxServices"] = 166] = "LegalzoomTaxServices";
	ProcessIds[ProcessIds["BeneficialOwnershipReports"] = 173] = "BeneficialOwnershipReports";
	ProcessIds[ProcessIds["Reinstatement"] = 192] = "Reinstatement";
	ProcessIds[ProcessIds["LivingTrust"] = 3] = "LivingTrust";
	ProcessIds[ProcessIds["Divorce"] = 4] = "Divorce";
	ProcessIds[ProcessIds["LastWillAndTestament"] = 6] = "LastWillAndTestament";
	ProcessIds[ProcessIds["LivingWill"] = 9] = "LivingWill";
	ProcessIds[ProcessIds["PowerOfAttorney"] = 11] = "PowerOfAttorney";
	ProcessIds[ProcessIds["NameChange"] = 15] = "NameChange";
	ProcessIds[ProcessIds["RealEstateDeedTransfer"] = 48] = "RealEstateDeedTransfer";
	ProcessIds[ProcessIds["SmallClaimsFillings"] = 22] = "SmallClaimsFillings";
	ProcessIds[ProcessIds["RealEstateLease"] = 38] = "RealEstateLease";
	ProcessIds[ProcessIds["PetProtectionAgreement"] = 100] = "PetProtectionAgreement";
	ProcessIds[ProcessIds["EPVault"] = 99] = "EPVault";
	ProcessIds[ProcessIds["LastWill_Spanish"] = 126] = "LastWill_Spanish";
	ProcessIds[ProcessIds["PowerOfAttorney_Spanish"] = 127] = "PowerOfAttorney_Spanish";
	ProcessIds[ProcessIds["LivingWill_Spanish"] = 128] = "LivingWill_Spanish";
	ProcessIds[ProcessIds["LivingTrustTransferDeed"] = 146] = "LivingTrustTransferDeed";
	ProcessIds[ProcessIds["EPBundle"] = 149] = "EPBundle";
	ProcessIds[ProcessIds["LegalZoomLifePlan"] = 152] = "LegalZoomLifePlan";
	ProcessIds[ProcessIds["EPSubscription"] = 153] = "EPSubscription";
	ProcessIds[ProcessIds["Prenup"] = 174] = "Prenup";
	ProcessIds[ProcessIds["EP2Bundle"] = 178] = "EP2Bundle";
	ProcessIds[ProcessIds["WillBundle"] = 180] = "WillBundle";
	ProcessIds[ProcessIds["TrustBundle"] = 181] = "TrustBundle";
	ProcessIds[ProcessIds["EpUnlimitedRevisions"] = 94] = "EpUnlimitedRevisions";
	ProcessIds[ProcessIds["BussinessContractReview"] = 184] = "BussinessContractReview";
	ProcessIds[ProcessIds["Trademark"] = 7] = "Trademark";
	ProcessIds[ProcessIds["Copyright"] = 8] = "Copyright";
	ProcessIds[ProcessIds["TrademarkSearch"] = 13] = "TrademarkSearch";
	ProcessIds[ProcessIds["TrademarkMonitoring"] = 14] = "TrademarkMonitoring";
	ProcessIds[ProcessIds["ProvisionalPatent_SelfHelp"] = 19] = "ProvisionalPatent_SelfHelp";
	ProcessIds[ProcessIds["TrademarkAssignment"] = 55] = "TrademarkAssignment";
	ProcessIds[ProcessIds["TrademarkSection8Declaration"] = 51] = "TrademarkSection8Declaration";
	ProcessIds[ProcessIds["TrademarkSection9Renewal"] = 52] = "TrademarkSection9Renewal";
	ProcessIds[ProcessIds["TrademarkStatementOfUse"] = 53] = "TrademarkStatementOfUse";
	ProcessIds[ProcessIds["TrademarkStatementOfUseExtension"] = 54] = "TrademarkStatementOfUseExtension";
	ProcessIds[ProcessIds["PatentSearch"] = 65] = "PatentSearch";
	ProcessIds[ProcessIds["ProvisionalPatentAttyAssisted"] = 67] = "ProvisionalPatentAttyAssisted";
	ProcessIds[ProcessIds["UtilityPatent"] = 70] = "UtilityPatent";
	ProcessIds[ProcessIds["UtilityPatentStepII"] = 71] = "UtilityPatentStepII";
	ProcessIds[ProcessIds["DesignPatent"] = 69] = "DesignPatent";
	ProcessIds[ProcessIds["ProfessionalPatentDrawings"] = 84] = "ProfessionalPatentDrawings";
	ProcessIds[ProcessIds["AttorneyLedTrademarkRegistration"] = 150] = "AttorneyLedTrademarkRegistration";
	ProcessIds[ProcessIds["Bankruptcy"] = 60] = "Bankruptcy";
	ProcessIds[ProcessIds["AttorneyPreparedPrenuptialAgreements"] = 72] = "AttorneyPreparedPrenuptialAgreements";
	ProcessIds[ProcessIds["ContractReview"] = 73] = "ContractReview";
	ProcessIds[ProcessIds["SeparationAgreement"] = 85] = "SeparationAgreement";
	ProcessIds[ProcessIds["DemandLetter"] = 86] = "DemandLetter";
	ProcessIds[ProcessIds["ContractDrafting"] = 87] = "ContractDrafting";
	ProcessIds[ProcessIds["EmploymentAgreementDrafting"] = 88] = "EmploymentAgreementDrafting";
	ProcessIds[ProcessIds["ChildSupportModification"] = 89] = "ChildSupportModification";
	ProcessIds[ProcessIds["ChildCustodyModification"] = 90] = "ChildCustodyModification";
	ProcessIds[ProcessIds["SpousalSupportModification"] = 91] = "SpousalSupportModification";
	ProcessIds[ProcessIds["AttorneyConsultation"] = 95] = "AttorneyConsultation";
	ProcessIds[ProcessIds["PreNuptialsReview"] = 103] = "PreNuptialsReview";
	ProcessIds[ProcessIds["WebsiteTermOfService"] = 104] = "WebsiteTermOfService";
	ProcessIds[ProcessIds["LegalSeparation"] = 105] = "LegalSeparation";
	ProcessIds[ProcessIds["PostNuptialAgreement"] = 106] = "PostNuptialAgreement";
	ProcessIds[ProcessIds["FranchiseAgreementReview"] = 92] = "FranchiseAgreementReview";
	ProcessIds[ProcessIds["StepparentAdoption"] = 96] = "StepparentAdoption";
	ProcessIds[ProcessIds["TrademarkDisputeLetter"] = 97] = "TrademarkDisputeLetter";
	ProcessIds[ProcessIds["HomeSaleAgreement"] = 98] = "HomeSaleAgreement";
	ProcessIds[ProcessIds["Guardianship"] = 101] = "Guardianship";
	ProcessIds[ProcessIds["BusinessAdvantageProStandalone"] = 109] = "BusinessAdvantageProStandalone";
	ProcessIds[ProcessIds["LegalAdvantagePlusStandalone"] = 112] = "LegalAdvantagePlusStandalone";
	ProcessIds[ProcessIds["BusinessAdvantageProAttorneyConsultation"] = 122] = "BusinessAdvantageProAttorneyConsultation";
	ProcessIds[ProcessIds["BusinessAdvantageProAttorneyConsultation_IP"] = 123] = "BusinessAdvantageProAttorneyConsultation_IP";
	ProcessIds[ProcessIds["LegalAdvantagePlusAttorneyConsultation"] = 124] = "LegalAdvantagePlusAttorneyConsultation";
	ProcessIds[ProcessIds["PreSaleConsultationTrial_LAP"] = 129] = "PreSaleConsultationTrial_LAP";
	ProcessIds[ProcessIds["PreSaleConsultationTrial_BAP"] = 130] = "PreSaleConsultationTrial_BAP";
	ProcessIds[ProcessIds["LegalAdvantagePlusStandalone_Spanish"] = 131] = "LegalAdvantagePlusStandalone_Spanish";
	ProcessIds[ProcessIds["BusinessAdvantageProStandalone_Spanish"] = 132] = "BusinessAdvantageProStandalone_Spanish";
	ProcessIds[ProcessIds["PrenuptialAgreement"] = 133] = "PrenuptialAgreement";
	ProcessIds[ProcessIds["LegalSettlementPlans_LAP"] = 135] = "LegalSettlementPlans_LAP";
	ProcessIds[ProcessIds["LegalSettlementPlans_BAP"] = 136] = "LegalSettlementPlans_BAP";
	ProcessIds[ProcessIds["LegalSettlementPlans_BAP_IP"] = 137] = "LegalSettlementPlans_BAP_IP";
	ProcessIds[ProcessIds["Divorce_ASD"] = 102] = "Divorce_ASD";
	ProcessIds[ProcessIds["LegalZoomEmployeeAdvantagePlan"] = 138] = "LegalZoomEmployeeAdvantagePlan";
	ProcessIds[ProcessIds["BusinessAdvantagePro_PartnerSales"] = 139] = "BusinessAdvantagePro_PartnerSales";
	ProcessIds[ProcessIds["LegalAdvantagePlus_PartnerSales"] = 140] = "LegalAdvantagePlus_PartnerSales";
	ProcessIds[ProcessIds["BusinessAdvantagePro_3rdPartySales"] = 141] = "BusinessAdvantagePro_3rdPartySales";
	ProcessIds[ProcessIds["LegalAdvantagePlus_3rdPartySales"] = 142] = "LegalAdvantagePlus_3rdPartySales";
	ProcessIds[ProcessIds["ManagedPlans"] = 143] = "ManagedPlans";
	ProcessIds[ProcessIds["SubscribeWithAmazon"] = 151] = "SubscribeWithAmazon";
	ProcessIds[ProcessIds["FinancialConsultation"] = 154] = "FinancialConsultation";
	ProcessIds[ProcessIds["InsuranceConsultation"] = 155] = "InsuranceConsultation";
	ProcessIds[ProcessIds["AttorneyAssistedFormationStandalone"] = 163] = "AttorneyAssistedFormationStandalone";
	ProcessIds[ProcessIds["LegalZoomTaxSubscriptions"] = 167] = "LegalZoomTaxSubscriptions";
	ProcessIds[ProcessIds["SubscriptionProducts"] = 94] = "SubscriptionProducts";
	ProcessIds[ProcessIds["Books"] = 171] = "Books";
	ProcessIds[ProcessIds["LegalForm"] = 62] = "LegalForm";
	ProcessIds[ProcessIds["LCP_LastWill"] = 113] = "LCP_LastWill";
	ProcessIds[ProcessIds["LCP_LivingWill"] = 114] = "LCP_LivingWill";
	ProcessIds[ProcessIds["LCP_Subscription"] = 115] = "LCP_Subscription";
	ProcessIds[ProcessIds["LCP_AutomotiveBillOfSale"] = 117] = "LCP_AutomotiveBillOfSale";
	ProcessIds[ProcessIds["LCP_DownloadableForms"] = 116] = "LCP_DownloadableForms";
	ProcessIds[ProcessIds["DomainManagement"] = 160] = "DomainManagement";
	ProcessIds[ProcessIds["GSuite"] = 161] = "GSuite";
	ProcessIds[ProcessIds["None"] = 0] = "None";
	return ProcessIds;
}({});
const PROCESS_IDS_SUPPORTED_WORKSPACES_WITH_TASKS = new Set([
	ProcessIds.Inc,
	ProcessIds.LLC,
	ProcessIds.DBA,
	ProcessIds.NonProfit
]);
const PROCESS_IDS_SUPPORTED_WORKSPACES_WITHOUT_TASKS = new Set([
	ProcessIds.LimitedPartnership,
	ProcessIds.LimitedLiabilityPartnership,
	ProcessIds.Amendment,
	ProcessIds.CorporateDissolution,
	ProcessIds.ForeignQualification,
	ProcessIds.SmallClaims,
	ProcessIds.SellersPermit,
	ProcessIds.StateTaxID,
	ProcessIds.Conversion,
	ProcessIds.CertificateOfGoodStanding,
	ProcessIds.BusinessLicenses,
	ProcessIds.NonProfit501c3Preparation,
	ProcessIds.GeneralPartnershipAgreement,
	ProcessIds.JointVentureAgreement,
	ProcessIds.EntityNameAvailabilityCheck,
	ProcessIds.CompanyCertificates,
	ProcessIds.CompanySeal,
	ProcessIds.CorporateKit,
	ProcessIds.InitialReports,
	ProcessIds.AnnualReports,
	ProcessIds.RegisteredAgentServices,
	ProcessIds.MinutesManagerSubscription,
	ProcessIds.EIN,
	ProcessIds.BylawsAndResolutions,
	ProcessIds.OperatingAgreements,
	ProcessIds.CorporateMinutes,
	ProcessIds.SCorpPreparation,
	ProcessIds.EntityNameReservation,
	ProcessIds.ComplianceCalendar,
	ProcessIds.PartnerProducts_CTN,
	ProcessIds.BusinessTaxPreparation,
	ProcessIds.BusinessTaxConsultation,
	ProcessIds.LegalzoomTaxServices
]);
const PROCESS_IDS_BUSINESS = [...Array.from(PROCESS_IDS_SUPPORTED_WORKSPACES_WITH_TASKS), ...Array.from(PROCESS_IDS_SUPPORTED_WORKSPACES_WITHOUT_TASKS)];
const PROCESS_IDS_PERSONAL = [
	ProcessIds.LivingTrust,
	ProcessIds.Divorce,
	ProcessIds.LastWillAndTestament,
	ProcessIds.LivingWill,
	ProcessIds.PowerOfAttorney,
	ProcessIds.NameChange,
	ProcessIds.RealEstateDeedTransfer,
	ProcessIds.SmallClaimsFillings,
	ProcessIds.RealEstateLease,
	ProcessIds.PetProtectionAgreement,
	ProcessIds.EPVault,
	ProcessIds.LastWill_Spanish,
	ProcessIds.PowerOfAttorney_Spanish,
	ProcessIds.LivingWill_Spanish,
	ProcessIds.LivingTrustTransferDeed,
	ProcessIds.EPBundle,
	ProcessIds.LegalZoomLifePlan,
	ProcessIds.EPSubscription,
	ProcessIds.WillBundle,
	ProcessIds.TrustBundle,
	ProcessIds.EP2Bundle
];
const PROCESS_IDS_IP = [
	ProcessIds.Trademark,
	ProcessIds.Copyright,
	ProcessIds.TrademarkSearch,
	ProcessIds.TrademarkMonitoring,
	ProcessIds.ProvisionalPatent_SelfHelp,
	ProcessIds.TrademarkAssignment,
	ProcessIds.TrademarkSection8Declaration,
	ProcessIds.TrademarkSection9Renewal,
	ProcessIds.TrademarkStatementOfUse,
	ProcessIds.TrademarkStatementOfUseExtension,
	ProcessIds.PatentSearch,
	ProcessIds.ProvisionalPatentAttyAssisted,
	ProcessIds.UtilityPatent,
	ProcessIds.UtilityPatentStepII,
	ProcessIds.DesignPatent,
	ProcessIds.ProfessionalPatentDrawings,
	ProcessIds.AttorneyLedTrademarkRegistration
];
const PROCESS_IDS_EPV2 = [
	ProcessIds.WillBundle,
	ProcessIds.TrustBundle,
	ProcessIds.EP2Bundle,
	ProcessIds.EpUnlimitedRevisions
];
const PROCESS_IDS_ATTORNEY_SERVICES = [
	ProcessIds.Bankruptcy,
	ProcessIds.AttorneyPreparedPrenuptialAgreements,
	ProcessIds.ContractReview,
	ProcessIds.SeparationAgreement,
	ProcessIds.DemandLetter,
	ProcessIds.ContractDrafting,
	ProcessIds.EmploymentAgreementDrafting,
	ProcessIds.ChildSupportModification,
	ProcessIds.ChildCustodyModification,
	ProcessIds.SpousalSupportModification,
	ProcessIds.AttorneyConsultation,
	ProcessIds.PreNuptialsReview,
	ProcessIds.WebsiteTermOfService,
	ProcessIds.LegalSeparation,
	ProcessIds.PostNuptialAgreement,
	ProcessIds.FranchiseAgreementReview,
	ProcessIds.StepparentAdoption,
	ProcessIds.TrademarkDisputeLetter,
	ProcessIds.HomeSaleAgreement,
	ProcessIds.Guardianship,
	ProcessIds.BusinessAdvantageProStandalone,
	ProcessIds.LegalAdvantagePlusStandalone,
	ProcessIds.BusinessAdvantageProAttorneyConsultation,
	ProcessIds.BusinessAdvantageProAttorneyConsultation_IP,
	ProcessIds.LegalAdvantagePlusAttorneyConsultation,
	ProcessIds.PreSaleConsultationTrial_LAP,
	ProcessIds.PreSaleConsultationTrial_BAP,
	ProcessIds.LegalAdvantagePlusStandalone_Spanish,
	ProcessIds.BusinessAdvantageProStandalone_Spanish,
	ProcessIds.PrenuptialAgreement,
	ProcessIds.LegalSettlementPlans_LAP,
	ProcessIds.LegalSettlementPlans_BAP,
	ProcessIds.LegalSettlementPlans_BAP_IP,
	ProcessIds.Divorce_ASD,
	ProcessIds.LegalZoomEmployeeAdvantagePlan,
	ProcessIds.BusinessAdvantagePro_PartnerSales,
	ProcessIds.LegalAdvantagePlus_PartnerSales,
	ProcessIds.BusinessAdvantagePro_3rdPartySales,
	ProcessIds.LegalAdvantagePlus_3rdPartySales,
	ProcessIds.ManagedPlans,
	ProcessIds.SubscribeWithAmazon,
	ProcessIds.FinancialConsultation,
	ProcessIds.InsuranceConsultation,
	ProcessIds.AttorneyAssistedFormationStandalone,
	ProcessIds.LegalZoomTaxSubscriptions,
	ProcessIds.SubscriptionProducts
];
const PROCESS_IDS_ATTORNEY_SERVICES_AS_BUSINESS = [
	ProcessIds.DemandLetter,
	ProcessIds.ContractDrafting,
	ProcessIds.EmploymentAgreementDrafting,
	ProcessIds.WebsiteTermOfService,
	ProcessIds.FranchiseAgreementReview,
	ProcessIds.TrademarkDisputeLetter,
	ProcessIds.BusinessAdvantageProStandalone,
	ProcessIds.BusinessAdvantageProAttorneyConsultation,
	ProcessIds.BusinessAdvantageProAttorneyConsultation_IP,
	ProcessIds.PreSaleConsultationTrial_BAP,
	ProcessIds.BusinessAdvantageProStandalone_Spanish,
	ProcessIds.LegalSettlementPlans_BAP,
	ProcessIds.LegalSettlementPlans_BAP_IP,
	ProcessIds.BusinessAdvantagePro_PartnerSales,
	ProcessIds.BusinessAdvantagePro_3rdPartySales,
	ProcessIds.AttorneyAssistedFormationStandalone,
	ProcessIds.LegalZoomTaxSubscriptions
];
const PROCESS_IDS_ATTORNEY_SERVICES_AS_PERSONAL = [
	ProcessIds.Bankruptcy,
	ProcessIds.AttorneyPreparedPrenuptialAgreements,
	ProcessIds.SeparationAgreement,
	ProcessIds.ChildSupportModification,
	ProcessIds.ChildCustodyModification,
	ProcessIds.SpousalSupportModification,
	ProcessIds.PreNuptialsReview,
	ProcessIds.Divorce_ASD,
	ProcessIds.LegalSeparation,
	ProcessIds.PostNuptialAgreement,
	ProcessIds.HomeSaleAgreement,
	ProcessIds.Guardianship,
	ProcessIds.StepparentAdoption,
	ProcessIds.LegalAdvantagePlusStandalone,
	ProcessIds.LegalAdvantagePlusAttorneyConsultation,
	ProcessIds.PreSaleConsultationTrial_LAP,
	ProcessIds.PrenuptialAgreement,
	ProcessIds.LegalSettlementPlans_LAP,
	ProcessIds.LegalAdvantagePlusStandalone_Spanish,
	ProcessIds.LegalZoomEmployeeAdvantagePlan,
	ProcessIds.LegalAdvantagePlus_PartnerSales,
	ProcessIds.LegalAdvantagePlus_3rdPartySales
];
const PROCESS_IDS_RESELLER_SERVICES = [ProcessIds.DomainManagement, ProcessIds.GSuite];
const PROCESS_IDS_OTHER = [
	ProcessIds.ContractReview,
	ProcessIds.AttorneyConsultation,
	ProcessIds.ManagedPlans,
	ProcessIds.SubscribeWithAmazon,
	ProcessIds.FinancialConsultation,
	ProcessIds.InsuranceConsultation,
	ProcessIds.SubscriptionProducts,
	ProcessIds.LegalForm
];
const QUALIFIED_FOR_INTERSTITIAL_OFFERS = [...PROCESS_IDS_SUPPORTED_WORKSPACES_WITHOUT_TASKS, ...PROCESS_IDS_IP];
const PROCESSS_IDS_COMPLIANCE_FILINGS = [
	ProcessIds.Amendment,
	ProcessIds.AnnualReports,
	ProcessIds.BeneficialOwnershipReports,
	ProcessIds.CorporateDissolution,
	ProcessIds.InitialReports,
	ProcessIds.EIN,
	ProcessIds.CertificateOfGoodStanding,
	ProcessIds.Conversion,
	ProcessIds.ForeignQualification,
	ProcessIds.RegisteredAgentServices,
	ProcessIds.BylawsAndResolutions,
	ProcessIds.OperatingAgreements,
	ProcessIds.Reinstatement
];
/** Process IDs that use direct HFT/IQ links (no resume-questionnaire POST wrapper). */
const PROCESS_IDS_REDT_IQ = [ProcessIds.RealEstateDeedTransfer];
(function(_ProcessIds) {
	const reverseMap = buildReverseMap(ProcessIds);
	function name(status) {
		return reverseMap.get(status);
	}
	_ProcessIds.name = name;
})(ProcessIds || (ProcessIds = {}));
//#endregion
export { PROCESSS_IDS_COMPLIANCE_FILINGS, PROCESS_IDS_ATTORNEY_SERVICES, PROCESS_IDS_ATTORNEY_SERVICES_AS_BUSINESS, PROCESS_IDS_ATTORNEY_SERVICES_AS_PERSONAL, PROCESS_IDS_BUSINESS, PROCESS_IDS_EPV2, PROCESS_IDS_IP, PROCESS_IDS_OTHER, PROCESS_IDS_PERSONAL, PROCESS_IDS_REDT_IQ, PROCESS_IDS_RESELLER_SERVICES, PROCESS_IDS_SUPPORTED_WORKSPACES_WITHOUT_TASKS, PROCESS_IDS_SUPPORTED_WORKSPACES_WITH_TASKS, ProcessIds, QUALIFIED_FOR_INTERSTITIAL_OFFERS };

//# sourceMappingURL=process-ids.mjs.map